import React from 'react'
import { IncentiveGetApi, IncentiveDeleteApi, IncentiveUpdateApi } from '../../../../services/api'
import { deleteDataFromApi, getDataFromApi, putDataFromApi } from '../../../../services/commonServices';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import { getUserDetails } from '../../../../services/commonFunction';

export const handleGetIncentive = async (incentivesId, setFormData, status, setIsOverlayLoader) => {
    try {
        const getIncentives = IncentiveGetApi(incentivesId);
        setIsOverlayLoader(true)
        const res = await getDataFromApi(getIncentives);

        if (res?.data?.status === 200) {
            const data = res?.data?.data;
            setFormData((previousData) => {
                // console.log("object",data?.incentive_invoice_details?.im_plant_year)
                return {
                    ...previousData,
                    0: {
                        ...previousData[0],
                        ...data,
                        incentive_client_id: data?.incentive_client_id_details?.cust_name,
                        incentive_invoice_id: data?.incentive_invoice_details?.im_id,
                        incentive_invoice_number: data?.incentive_invoice_details?.im_invoicenumber,
                        incentive_mode: data?.incentive_mode,
                        im_plant_year: data?.incentive_invoice_details?.im_plant_year,
                        incentive_price: data?.incentive_price,
                        incentive_place_of_work: data?.incentive_place_of_work_details?.pow_name,
                        incentive_vessel_quantity: data?.incentive_vessel_quantity,
                        incentive_work_completion_date: data?.incentive_work_completion_date,
                        incentive_billing_date: data?.incentive_billing_date,
                        incentive_delay_billing_days: data?.incentive_delay_billing_days + " days",
                        incentive_billing_amt_inr: data?.incentive_billing_amt_inr,
                        incentive_expense_amt: parseFloat(data?.incentive_expense_amt).toFixed(2),
                        incentive_profit_against_work: parseFloat(data?.incentive_profit_against_work).toFixed(2),
                        incentive_payment_collection_date: data?.incentive_payment_collection_date || data?.pc_date,
                        incentive_delay_payment_days: data?.incentive_delay_payment_days + " days",
                        incentive_total_delay_days: data?.incentive_total_delay_days + " days",
                        incentive_bonus_amount: data?.incentive_bonus_amount,
                        incentive_incentive_amount: data?.incentive_incentive_amount,
                        incentive_incentive_amount_perc:
                            data?.incentive_incentive_amount_perc != null
                                ? `${data.incentive_incentive_amount_perc}%`
                                : "",
                        incentive_penalty_amount: data?.incentive_penalty_amount,
                        incentive_receivable_amount: data?.incentive_receivable_amount,
                        incentive_sales_lead_share: data?.incentive_sales_lead_share,
                        incentive_actual_sales_share: data?.incentive_actual_sales_share,
                        incentive_operations_share: data?.incentive_operations_share,
                        incentive_collections_share: data?.incentive_collections_share,
                        incentive_collections_share_pct: data?.incentive_collections_share_pct != null
                            ? `${data.incentive_collections_share_pct}%`
                            : null,
                        incentive_operations_share_pct: data?.incentive_operations_share_pct != null
                            ? `${data.incentive_operations_share_pct}%`
                            : null,

                        incentive_sales_lead_share_pct: data?.incentive_sales_lead_share_pct != null
                            ? `${data.incentive_sales_lead_share_pct}%`
                            : null,

                        incentive_actual_sales_share_pct: data?.incentive_actual_sales_share_pct != null
                            ? `${data.incentive_actual_sales_share_pct}%`
                            : null,
                        incentive_remarks: data?.incentive_remarks,
                    }
                }
            })
            setIsOverlayLoader(false);
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // Handle error if needed
    }
};


export const handleIncentivePost = async (
    formData,
    setIsOverlayLoader,
    navigate
) => {
    try {
        const payload = {
            incentive_status: 1
        };

        let updateIncentive = IncentiveUpdateApi(formData[0]?.incentive_id);
        const res = await putDataFromApi(updateIncentive, payload);

        if (res?.data?.status === 200) {
            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            navigate("/incentivesList");
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        // Handle error if needed
    }
};


export const handleIncentiveDelete = async (
    incentiveId,
    setIsDelete,
    getAllListingData,
    setPopupIndex
) => {
    try {
        let incentiveDelete = IncentiveDeleteApi(incentiveId)
        let res = await deleteDataFromApi(incentiveDelete);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }
};
